export default class User {
    constructor(user = {}) {
        this.id = user.id;
        this.email = user.email;
        this.userId = user.user_id;
        this.isAdmin = user.is_admin;
        this.adminName = user.admin_name;
        this.companyName = user.company_name;
        this.companyId = user.company_id;
        this.companyType = user.company_type;
        if (user.company_type==2){
            this.company_list = (user.company_list || []).map(el => {
                if(el.branches) {
                    delete el.branches;
                }
                return el;
            });
        }
        this.isSettingsVisible = user.is_visible;
        this.serviceType = user.service_type;
        this.isSettingsVisible = user.is_visible;
        this.token = user.token;
        this.userImage = user.image_url;
        this.branchName = user.branch_name;
        this.branchId = user.branch_id;
        this.isApprover = user.is_approver;
        this.isChallengePriceForm = user.is_cp_form;
        this.originVehicleOrder = user.origin_vehicle_order_chain_type || {};
        this.isPlanner = user.is_planner;
        this.hasSubplant = user.has_subplant;
        this.contracting = user.Contracting;
        this.indenting = user.Indenting;
        this.accounts = user.Accounts;
        this.reports = user.Reports;
        this.tracking = user['Tracking/VIMS'];
        this.isTk11 = user.isTk11;
        this.menuShow = user.menus_to_hide || '';
        this.indentCategory = user.bound || '';
        this.selectFields = user.tabs_to_hide || [];
        this.fieldsToDisplay = user.fields_to_display || '';
        this.autoPopulateFromLocation = user.auto_populate_from_location || '';
        this.consigneeLocationSearch = user.consignee_location_search || '';
        this.vivoFields = user.vivo_dashboard_hide || '';
        this.vivoDashboardAutoPopulate = user.vivo_dashboard_auto_populate || {};
        // this.showTracking = user.show_tracking || '';
        this.transitDashboard = user.transit_dashboard_hide || [];
        this.autoMoves = user.auto_moves || '';
        this.transitDashboardType = user.transit_dashboard_type || 1;
        this.isHOUser = user.is_ho_user || '';
        this.manualEnabled = user.manual_enabled || false;
        this.isHODUser = user.is_hod_user || '';
        this.isIndentAdmin = user.is_indent_admin || '';
        this.adminFieldList = user.admin_field_list || [];
        this.indentCuttOff = user.mandatory_indent_cutoff_time || '';
        this.vehicleReportingDate = user.mandatory_vehicle_report_time || '';
        this.isVehicleApprover = user.is_vehicle_approver || false;
        this.vehicleMasterAccess = user.vehicle_master_access || false;
        this.hasApproval = user.has_vehicle_approval || false;
        this.weighBridge = user.weigh_bridge || '';
        this.isAutoMoveEnabled = user.is_auto_move_enabled || false;
        this.autoMoveIds = user.auto_moves_id || [];
        this.tK11Dashboard = user.has_Tk11_access || '';
        this.rfqTypes = user.rfq_types || '';
        this.ammendmentLevel = user.ammendment_app_level || '';
        this.uploadRate = user.upload_rates;
        this.uploadNumberOfTrucks = user.upload_number_of_trucks;
        this.enabledClosedRfq  = user.enabled_closed_rfq || false;
        this.enabledAcceptanceCeilingPrice= user.enabled_acceptance_of_ceiling_price || false;
        this.isAccessNewFeature = user.access_new_feature || [];
        this.showBoundType= user.show_bound_type || false;
        this.showLppDetails = user.show_lpp_details || false;
        this.showPinCodeDetails = user.show_pincode_details || false;
        this.misList = user.mis_list || [];
        this.isShowDphDetails = user.is_show_dph_details || false;
        this.idleTimeoutDuration = user.idle_timeout_duration || (60 * 5);
        this.tk11_routecode_validation = user.tk11_routecode_validation || false;
        this.isSSOLogin = user.is_sso_login || false;
        this.forceAuthentication = user.force_auth || false;
        this.logoutTimeoutDuration = user.logout_delay_duration || (60*60);
        this.is_disposal_access = user.is_disposal_access || false;
        this.is_route_master = user.is_route_master || true;
        this.isEditContractTenure = user.isEditContractTenure;
        this.isCreateMasterData = user.isCreateMasterData || false;
        this.isSpotContract = user.isSpotContract || false;
        this.isDphApprover = user.isDphApprover || false;
        this.roleName = user.role_name || '';
        this.actions = user.actions;
        this.oldAccount = user.use_old_accounts || false;
        this.companyTextID = user.company_text_id;
        this.company_text_id = user.company_text_id;
        this.isDepotUser = user.is_depot_user || false;
        this.is_rlm_user = user.is_rlm_user || false;
        this.edit_bidding_time = user.edit_bidding_time || false;
        this.access_slab_offline = user.access_slab_offline || false;
        this.is_active = user.is_active;
    }
}
